import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as offerActions from '../../../redux/newOffer';
import MainWindow from '../../Wrappers/MainWindow';
import Frame from './../../Wrappers/Frame';
import OfferForm1 from './OfferForm1';
import OfferForm2 from './OfferForm2';
import OfferForm3 from './OfferForm3';
import CancelCreateOffer from './CancelCreateOffer';
import './../Partials/Offer.css';

interface Props {
  offer: any;
  business: Business;
  offerActions: any;
}

export const offerSteps = {
  gift: [1, null, 3],
  sponsored_content: [1, null, 3]
};

class CreateOffer extends React.Component<Props, {}> {

  render() {
    document.title = 'Create Offer • Neoncoat Brands Tool';
    let pages = [<></>, <OfferForm1 />, <OfferForm2 />, <OfferForm3 />];

    if (!this.props.business.id) return <MainWindow page="createOffer" />;
    if (!this.props.offer.page) {
      this.props.offerActions.createNewOffer(this.props.business);
      return <MainWindow page="createOffer" />;
    }

    const theOfferSteps:Array<Number> = offerSteps[this.props.offer.type];
    const maxSteps = theOfferSteps ? theOfferSteps.filter(x => x !== null).length : 3;
    const diffSteps = theOfferSteps ? theOfferSteps.filter(x => x !== null && x < this.props.offer.page).length : 0;

    return (
      <MainWindow page="createOffer">
        {this.props.offer.page && (
          <Frame
            title={`Create offer: Step ${this.props.offer.page - diffSteps} of ${maxSteps}`}
            right={<CancelCreateOffer />}
          >
            {pages[this.props.offer.page]}
          </Frame>
        )}
      </MainWindow>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    offerActions: bindActionCreators(offerActions, dispatch),
  };
}

export default connect(
  ({ newOffer, business }: any) => ({ offer: newOffer, business }),
  mapDispatchToProps
)(CreateOffer);
